import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  soloIsFetching: false,
  soloDidInvalidate: false,
  soloRawFiles: []
});

function soloUploadReducer(state = initialState, action) {
  switch (action.type) {
    case types.SIGN_OUT_COMPLETE:
      return initialState;
    case types.WORKAREA_SET:
      return initialState;

    case types.SOLO_UPLOAD_FILES_INVALIDATE:
      return state.set("soloDidInvalidate", true);

    case types.SOLO_UPLOAD_FILES_FETCH_REQUEST:
      return state.merge({
        soloDidInvalidate: false,
        soloIsFetching: true
      });

    case types.SOLO_UPLOAD_FILES_FETCH_SUCCESS:
      return state.withMutations(s =>
        s
          .merge({
            soloDidInvalidate: false,
            soloIsFetching: false,
            soloLastUpdated: action.meta.receivedAt
          })
          .set(
            "soloRawFiles",
            Immutable.fromJS(
              action.payload.files.map(f => ({
                status: "success",
                name: f.filename,
                data: f
              }))
            )
          )
      );

    case types.SOLO_UPLOAD_FILE_REQUEST:
      return state.update("soloRawFiles", soloRawFiles =>
        soloRawFiles
          .filter(f => f.get("name") !== action.payload.name)
          .push(
            Immutable.fromJS({
              status: "pending",
              name: action.payload.name,
              data: {
                workarea: action.payload.workarea,
                organization: action.payload.organization
              }
            })
          )
      );

    case types.SOLO_UPLOAD_FILE_SUCCESS:
      return state.update("soloRawFiles", soloRawFiles =>
        soloRawFiles.map(f => {
          if (f.get("name") === action.payload.name) {
            return f.set("status", "success");
          }
          return f;
        })
      );

    case types.SOLO_UPLOAD_FILE_ERROR:
      return state.update("soloRawFiles", soloRawFiles =>
        soloRawFiles.map(f => {
          if (f.get("name") === action.meta.name) {
            return f.merge({
              status: "error",
              message: action.payload.message
            });
          }
          return f;
        })
      );

    default:
      return state;
  }
}

export default soloUploadReducer;
